module.exports = __webpack_public_path__ + "static/media/lock.b5bc82c8.svg";